import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getReportsServicePayments(companyId, query) {
  return dataTransferWrap(
    ModulesMap.REPORTS_SERVICE_PAYMENTS,dtConfig[ModulesMap.REPORTS_SERVICE_PAYMENTS].getReportsServicePayments,
    {
      urlParams: {
        companyId
      },
      params: query,
    },
  )
}
function getReportsServicePayment(companyId, servicePaymentId, query) {
  return dataTransferWrap(ModulesMap.REPORTS_SERVICE_PAYMENTS,dtConfig[ModulesMap.REPORTS_SERVICE_PAYMENTS].getReportsServicePayment,
    {
      urlParams: {
        companyId, servicePaymentId
      },
      params: query,
    })
}
function getReportsServicePaymentPreview(companyId, servicePaymentId, query) {
  return dataTransferWrap(ModulesMap.REPORTS_SERVICE_PAYMENTS,dtConfig[ModulesMap.REPORTS_SERVICE_PAYMENTS].getReportsServicePaymentPreview,
    {
      urlParams: {
        companyId, servicePaymentId
      },
      params: query,
    })
}

export default {
  getReportsServicePayments,
  getReportsServicePayment,
  getReportsServicePaymentPreview,
}